import React, { useState } from 'react'
import { useModal } from '../contexts/ModalContext'
import AccordionServicos from './accordionServicos'
import CardServicos from './cardServicos'
import Container from './container'
import OtimizeSeuNegocio from './OtimizeSeuNegocio'

export default function FinopsBeneficios({ cards = [] }) {
  const [openAccordionId, setOpenAccordionId] = useState(null)
  const [expandedMobileIndex, setExpandedMobileIndex] = useState(null)
  const [hoveredIndex, setHoveredIndex] = useState(null)
  
  // Handle accordion toggle in mobile view
  const handleAccordionToggle = (index, isOpen) => {
    if (isOpen) {
      // Close any previously opened accordion
      if (expandedMobileIndex !== null && expandedMobileIndex !== index) {
        // Find the previously opened accordion and close it
        const prevAccordion = document.querySelector(`[data-accordion-index="${expandedMobileIndex}"]`);
        if (prevAccordion) {
          prevAccordion.click();
        }
      }
      setExpandedMobileIndex(index);
      setOpenAccordionId(cards[index].id);
    } else if (expandedMobileIndex === index) {
      setExpandedMobileIndex(null);
      setOpenAccordionId(null);
    }
  }
  return (
    <div className="w-full bg-[#040116] bg-[url(/assets/beneficios-finops-mobile.png)] lg:bg-[url(/assets/cover-finops-beneficios.png)] pt-12 pb-18 md:pb-36 md:py-24 relative overflow-hidden bg-cover bg-center">
      <Container className="relative z-10 space-y-0">
        <section>
          <div className="text-white font-inter-regular text-2xl md:text-[60px] flex justify-center mb-12 md:mb-24">
            Benefícios
          </div>

          <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 gap-3">
            {cards.map((card, index) => (
              <div key={index} className="relative">
                <div 
                  className="relative mb-10" 
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <CardServicos
                    icon={card.icon}
                    iconHover={card.iconHover || card.icon}
                    title={card.title}
                    text={card.text}
                    glowColor={card.glowColor || '#A002CB'}
                    url={card.url}
                    className=" w-full"
                  />
                  
                  {/* OtimizeSeuNegocio component that appears on hover */}
                  <div 
                    className={`hidden md:block absolute left-0 right-0 bottom-[-90px] transition-all duration-300 ${hoveredIndex === index ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
                  >
                    <OtimizeSeuNegocio 
                      text="Otimize seu negócio!"
                      buttonText="Contratar"
                      useFormularioRD={true}
                      type="gradient"
                      className="w-full"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="md:hidden space-y-3">
            {cards.map((card, index) => (
              <div key={index} className="relative">
                <AccordionServicos
                  key={`mobile-${index}`}
                  {...card}
                  className="bg-[rgb(36,29,73)] backdrop-blur-[92px] text-left"
                  doesThereButton={false}
                  onToggle={(isOpen) => handleAccordionToggle(index, isOpen)}
                  accordionIndex={index}
                />
                
                {/* Mobile OtimizeSeuNegocio that appears when accordion is expanded */}
                <div 
                  className={`transition-all duration-300 ease-in-out transform w-full overflow-hidden
                    ${expandedMobileIndex === index ? 'max-h-[100px] opacity-100' : 'max-h-0 opacity-0'}`}
                  style={{
                    transitionProperty: 'max-height, opacity, transform',
                    transform: expandedMobileIndex === index ? 'translateY(0)' : 'translateY(-10px)',
                    zIndex: 20,
                    position: 'relative'
                  }}
                >
                  <OtimizeSeuNegocio 
                    text="Otimize seu negócio!"
                    buttonText="Contratar"
                    useFormularioRD={true}
                    type="gradient"
                    className="w-full mt-4"
                  />
                </div>
              </div>
            ))}
          </div>
        </section>


      </Container>
    </div>
  )
}
